import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { getMechanicalTestDataForHeat } from "@/pages/heat-report/repository/HeatReportRepository";

export const useMechanicalTestData = () => {
	const { state, actions } = useHeatReportContext();

	const loadMechanicalTestData = async (heatId: number) => {
		if (!heatId) {
			actions.setMechanicalTests(null);
			actions.setMechanicalSamples(null);
			actions.setMechanicalGradeLimits(null);
			actions.setMechanicalResultSources(null);
			return;
		}

		actions.setIsMechanicalDataLoading(true);

		try {
			const { samples, tests, sources } = await getMechanicalTestDataForHeat({
				heatId,
			});

			if (tests.ok) {
				actions.setMechanicalTests(tests.data.tables[0].rows);
			}

			if (sources.ok) {
				actions.setMechanicalResultSources(sources.data.tables[0].rows);
			}

			if (samples.ok) {
				actions.setMechanicalSamples(samples.data.tables[0].rows);
				// Grade limits are in the second table
				if (samples.data.tables[1]) {
					actions.setMechanicalGradeLimits(samples.data.tables[1].rows);
				}
			}
		} catch (error) {
			console.error("Error loading mechanical test data:", error);
			// Reset data on error
			actions.setMechanicalTests(null);
			actions.setMechanicalSamples(null);
			actions.setMechanicalGradeLimits(null);
			actions.setMechanicalResultSources(null);
		} finally {
			actions.setIsMechanicalDataLoading(false);
		}
	};

	return {
		loadMechanicalTestData,
		mechanicalTests: state.mechanicalTests,
		mechanicalSamples: state.mechanicalSamples,
		mechanicalGradeLimits: state.mechanicalGradeLimits,
		mechanicalResultSources: state.mechanicalResultSources,
		isMechanicalDataLoading: state.isMechanicalDataLoading,
	};
};
